import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("제공됩니다.")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("투명 음료 페트병 이외의 물품을 보내 주실 경우 "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("리워드가 제공되지 않습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("테라사이클 팀은 여러분이 보내 주신 박스를 하나하나 "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("모두 검수한답니다.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("수거 품목은 ‘투명 음료 페트병’이에요. "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("페이지 하단의 수거 가이드를 꼭 확인해주세요.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 선택해주세요. ")

import CampaignCheck, { Expose as CampaignCheckExpose } from '@/components/campaign/check.vue';
import CampaignQuiz, { Expose as CampaignQuizExpose } from '@/components/campaign/quiz.vue';
import CampaignParticipate, { Expose as CampaignParticipateExpose } from '@/components/campaign/participate.vue';
import { IProgram } from '@/types/program';
import { ref, reactive, inject, nextTick, computed } from 'vue';
import { ColorVariants, PEOPLE_COLLECTION_MAP } from '@/constants';
import _ from 'lodash';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import DialogSelectChallenge from '../dialog-select-challenge/index.vue';
interface Props {
  program: IProgram;
}
interface Info {
  title: string;
  content: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
  program: IProgram;
}

dayjs.extend(isBetween);




const dialog = reactive({
  info: false,
  step1: false,
  step2: false,
  step3: false,
});

const infoDialogProps = ref<Info>();
function showInfoDialog(info: Info) {
  infoDialogProps.value = info;
  showDialog('info');
}

const currentParticipateRound = computed(() => {
  return props.program.program_rounds?.find(item => dayjs().isBetween(item.participate_started_at, item.participate_ended_at));
});

const announcedOn = computed(() => {
  if (currentParticipateRound.value) {
    return dayjs(currentParticipateRound.value.participate_ended_at).add(2, 'day').format('MM/DD');
  }
  return '';
});

const quizRef = ref<CampaignQuizExpose>();
const checkRef = ref<CampaignCheckExpose>();
const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
async function onStart() {
  const valid = await checkRef.value?.check();
  if (valid) {
    await refreshPageData();
    await nextTick();
    const { show_participate_btn, campaign_quiz, participate_btn_msg } = props.program;
    if (show_participate_btn) {
      if (campaign_quiz) {
        quizRef.value?.startQuiz(campaign_quiz);
        return;
      }
      startParticipate();
      return;
    }
    // 不能参与的情况
    showInfoDialog({
      title: '',
      content: participate_btn_msg!
    });
  }
}

function startParticipate() {
  showDialog('step1');
}

function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}

function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

const groupTypes = _.map(PEOPLE_COLLECTION_MAP, (text, value) => ({ text, value }));

const form = reactive({
  collection_challenge: 2,
  people_collection: undefined,
  group_name: undefined,
  collecting_people_number: undefined
});

const participateRef = ref<CampaignParticipateExpose>();
function participate() {
  closeDialog();
  participateRef.value?.participate(form);
}

const formRef = ref<{ $el: HTMLFormElement }>();
function onParticipate() {
  const result = formRef.value?.$el.reportValidity();
  if (result) {
    participate();
  }
}

const router = useRouter();
function handleNavToRecordDetail() {
  participateRef.value?.closeDialog();
  closeDialog();
  router.push({ name: 'mine.programParticipationDetail', params: { id: props.program.participation_request_id } });
};

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_b_form_select_option = _resolveComponent("b-form-select-option")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", { onClick: onStart }, [
    _renderSlot(_ctx.$slots, "default"),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(CampaignCheck, {
        ref_key: "checkRef",
        ref: checkRef,
        "class-name": "dialog-campaign-cocacola-s4"
      }, null, 512),
      _createVNode(CampaignQuiz, {
        ref_key: "quizRef",
        ref: quizRef,
        program: __props.program,
        "class-name": "dialog-campaign-cocacola-s4",
        onSuccess: startParticipate
      }, null, 8, ["program"]),
      _createVNode(CampaignParticipate, {
        ref_key: "participateRef",
        ref: participateRef,
        "success-dialog-class-name": "dialog-campaign-participate-success",
        "error-dialog-class-name": "dialog-campaign-cocacola-s4",
        program: __props.program,
        "success-dialog-props": {
          title: '지원이 완료됐습니다!',
          content: `
원더플 피플이 되신 분들에게는 (${_unref(announcedOn)})에
개별 카카오톡 알림톡을 보내 드립니다.
당첨 발표 연락을 기다려주세요.

`,
          btns: [
            { text: '지원 내역 확인', style: _unref(ColorVariants).dark, click: () => handleNavToRecordDetail() },
            { text: '완료', style: _unref(ColorVariants).danger, click: () => participateRef.value?.closeDialog() },
          ]
        }
      }, null, 8, ["program", "success-dialog-props"]),
      _createVNode(DialogSelectChallenge, {
        visible: _unref(dialog).step1,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).step1) = $event)),
        modelValue: _unref(form).collection_challenge,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).collection_challenge) = $event)),
        onButtonClick: _cache[2] || (_cache[2] = ($event: any) => (showDialog('step2')))
      }, null, 8, ["visible", "modelValue"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).step2,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).step2) = $event)),
        class: "dialog-campaign-participate-step-2",
        title: "꼭 확인해주세요!",
        btns: [
          { text: '취소', style: _unref(ColorVariants).dark, click: () => closeDialog() },
          { text: '확인했어요!', style: _unref(ColorVariants).danger, click: () => showDialog('step3') },
        ]
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_unref(form).collection_challenge) + "개 박스 모두 45일 이내 수거 신청하셔야 리워드가 ", 1),
                _hoisted_3,
                _hoisted_4
              ]),
              _hoisted_5,
              _hoisted_6
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).step3,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_unref(dialog).step3) = $event)),
        class: "dialog-campaign-participate-step-3",
        title: "누구와 함께 하나요?",
        btns: [
          { text: '취소', style: _unref(ColorVariants).dark, click: () => closeDialog() },
          { text: '다음', style: _unref(ColorVariants).danger, click: () => onParticipate() },
        ]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_form, {
            ref_key: "formRef",
            ref: formRef,
            class: "dialog-content",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop","prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, { label: "참여 유형" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_select, {
                    id: "people_collection",
                    modelValue: _unref(form).people_collection,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).people_collection) = $event)),
                    name: "people_collection",
                    required: ""
                  }, {
                    first: _withCtx(() => [
                      _createVNode(_component_b_form_select_option, {
                        value: null,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupTypes), (item) => {
                        return (_openBlock(), _createBlock(_component_b_form_select_option, {
                          key: item.text,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_form_group, { label: "소속(또는 닉네임)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_input, {
                    id: "group_name",
                    modelValue: _unref(form).group_name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).group_name) = $event)),
                    name: "group_name",
                    placeholder: "테라사이클 코리아 팀",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_form_group, { label: "참여 인원" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_input, {
                    id: "collecting_people_number",
                    modelValue: _unref(form).collecting_people_number,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).collecting_people_number) = $event)),
                    name: "collecting_people_number",
                    placeholder: "5",
                    required: "",
                    type: "number"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, _mergeProps({
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_unref(dialog).info) = $event)),
        class: "dialog-campaign-cocacola-s4"
      }, infoDialogProps.value, {
        btns: [
          { text: '확인', style: _unref(ColorVariants).primary, click: () => closeDialog() }
        ]
      }), null, 16, ["visible", "btns"])
    ]))
  ]))
}
}

})